import React from 'react';
import {
  Autocomplete,
  FormControl,
  TextField,
  Box,
  Paper,
} from '@mui/material';
import RadioButtonUncheckedIcon from '@mui/icons-material/RadioButtonUnchecked';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';

import styles from './filterAutocomplete.style';

const FilterAutocomplete = ({
  value,
  onChange,
  loading = false,
  label = '',
  options,
  id = 'dropdown',
  minWidth = 'auto',
  width = '100%',
  ...props
}) => {
  const _handleOnChange = (_event, newValue) => {
    if (onChange) {
      onChange(newValue);
    }
  };

  const hasValue = value || value?.value;

  const renderPaper = ({ children }) => (
    <Paper sx={styles.paper} onMouseDown={(e) => e.preventDefault()}>
      {children}
    </Paper>
  );

  const renderOption = (autoCompleteProps, option) => {
    const isSelected =
      value && (option.value === value.value || value === option.value);
    return (
      <Box
        component="li"
        {...autoCompleteProps}
        key={option.value}
        sx={styles.selectItem}
      >
        {isSelected ? (
          <CheckCircleIcon sx={styles.radioIcon} />
        ) : (
          <RadioButtonUncheckedIcon sx={styles.radioUncheckedIcon} />
        )}
        {option.text || ''}
      </Box>
    );
  };
  const renderInput = (params) => {
    return (
      <TextField
        variant="outlined"
        label={label}
        data-testid={`input-${id}`}
        sx={{ ...styles.textfield, ...(hasValue && styles.textfieldWithValue) }}
        {...params}
      />
    );
  };

  return (
    <FormControl variant="outlined" sx={{ m: 0, width }}>
      <Box sx={styles.wrapper(minWidth)}>
        <Autocomplete
          disablePortal
          sx={styles.autocomplete}
          disabled={loading}
          value={value || null}
          onChange={_handleOnChange}
          loading={loading}
          ListboxProps={{ style: { maxHeight: 300 } }}
          isOptionEqualToValue={(option, newValue) => {
            return option.value === newValue.value;
          }}
          getOptionLabel={(option) => {
            if (typeof option === 'string' || option instanceof String) {
              return option;
            }
            return option?.text || option?.label;
          }}
          options={options}
          PaperComponent={renderPaper}
          renderOption={renderOption}
          renderInput={renderInput}
          size="small"
          {...props}
        />
      </Box>
    </FormControl>
  );
};

export default FilterAutocomplete;
